import React from 'react'

const Banner = () => {
    return (
        <div className="w-full py-3 font-semibold text-sm text-yellow-900 bg-gradient-to-r from-[#F0E68C] to-[#FDFEFF] flex items-center justify-center">
            <p className="flex items-center justify-center">👦Bhaiya : Build your resume with AI</p>
        </div>
)
}

export default Banner